import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-log',
    templateUrl: './log.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./log.component.css']
})
export class LogComponent implements OnInit {
  id: string;
  responseJson: string;
  hasApiError = false;
  apiError: string;

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.api.getLogsId$(this.id).subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.responseJson = JSON.stringify(res, null, 2).trim();
      },
      error: () => this.hasApiError = true,
    });
  }
}
